export default __webpack_public_path__ + "static/media/editar.1bc08e37.png";